import React from "react";

import { Card } from "semantic-ui-react";
import ButtonExport from "./ButtonExport";
import ColorPicker from "./ColorPicker";
import Switch from "./Switch";

function MultiOptions(props) {
    const lang = props.lang;

    function handleChange(id, value) {
        props.onChange(props.data.id, value, id);
    }

    return (
        <div className="col" style={{ width: "100%" }} id={props.data.id}>
            <p style={{ margin: "auto auto .6em" }}>{props.data.description[lang]}</p>
            {props.data.config.map((item, index) => {
                if (item.component === "colorPicker") {
                    return (<Card key={index} id={item.id} className="option-card-settings" fluid color="black" header={<ColorPicker onChange={handleChange} id={item.id} color={item.value} desc={item.description[lang]} />} />);
                } else if (item.component === "switch") {
                    return (<Card key={index} className="option-card-settings" fluid color={item.color} header={<Switch onChange={handleChange} lang={lang} data={item} />} />);
                } else if (item.component === "button") {
                    return (<Card key={index} id={item.id} className="option-card-settings" fluid color='red' header={<ButtonExport content={item.description[lang]} />} />);
                } else {
                    return null;
                }
            })}
        </div>
    );
}

export default MultiOptions;